import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send, MessageSquare, Github, Linkedin, CheckCircle } from 'lucide-react';
import emailjs from '@emailjs/browser';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  // Nouvel état pour gérer l'animation du bouton (Envoi en cours, Succès, Erreur)
  const [status, setStatus] = useState(''); 

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('sending'); // On change le bouton en "Envoi en cours..."

    // Les variables qui seront envoyées à ton modèle (Template) EmailJS
    const templateParams = {
      from_name: formData.name,
      reply_to: formData.email,
      subject: formData.subject,
      message: formData.message,
    };

    // ⚠️ REMPLACE CES 3 LIGNES PAR TES VRAIES CLÉS EMAILJS ⚠️
    emailjs.send(
      'service_s59gg7b',     // Ex: 'service_123abc'
      'template_5xtyval',    // Ex: 'template_456def'
      templateParams,
      'NuWf2a_WhFxDE2uSO'    
    )
    .then((response) => {
      console.log('Email envoyé avec succès !', response.status, response.text);
      setStatus('success');
      // On vide le formulaire pour faire propre
      setFormData({ name: '', email: '', subject: '', message: '' });
      // Le bouton redevient normal après 3 secondes
      setTimeout(() => setStatus(''), 3000);
    })
    .catch((err) => {
      console.error('Erreur lors de l\'envoi:', err);
      setStatus('error');
      setTimeout(() => setStatus(''), 3000);
    });
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        
        {/* EN-TÊTE MODERNE */}
        <div className="modern-section-header">
          <div className="modern-badge">
            <MessageSquare size={16} />
            <span>Contact</span>
          </div>
          <h2 className="modern-title">
            Me <span className="modern-highlight">Contacter</span>
          </h2>
          <p className="modern-subtitle">
            Prêt à collaborer sur votre prochain projet ? Créons quelque chose d'extraordinaire ensemble.
          </p>
        </div>

        <div className="contact-content-grid">
          
          {/* COLONNE GAUCHE : INFOS DE CONTACT */}
          <div className="contact-info-panel">
            <h3 className="info-title">Informations de Contact</h3>
            
            <div className="info-items">
              <div className="old-info-item">
                <div className="old-info-icon"><Mail size={22} /></div>
                <div className="old-info-details">
                  <h4>Email</h4>
                  <a href="mailto:contact@omaraldroubi.fr">contact@omaraldroubi.fr</a>
                </div>
              </div>

              <div className="old-info-item">
                <div className="old-info-icon"><Phone size={22} /></div>
                <div className="old-info-details">
                  <h4>Téléphone</h4>
                  <a href="tel:+33618709889">06 18 70 98 89</a>
                </div>
              </div>

              <div className="old-info-item">
                <div className="old-info-icon"><MapPin size={22} /></div>
                <div className="old-info-details">
                  <h4>Localisation</h4>
                  <p>Caen, Normandie, France</p>
                </div>
              </div>
            </div>

            <div className="contact-socials-modern">
              <div className="socials-flex">
                <a href="https://github.com/Omar-Aldroubi" target="_blank" rel="noopener noreferrer" className="modern-social-btn">
                  <Github size={18} />
                  <span>GitHub</span>
                </a>
                <a href="https://www.linkedin.com/in/omar-aldroubi-b43173291/" target="_blank" rel="noopener noreferrer" className="modern-social-btn">
                  <Linkedin size={18} />
                  <span>LinkedIn</span>
                </a>
              </div>
            </div>

            <div className="availability-badge">
              <div className="pulse-dot"></div>
              <span>Disponible pour de Nouveaux Projets</span>
            </div>
          </div>

          {/* COLONNE DROITE : FORMULAIRE */}
          <div className="contact-form-panel">
            <h3 className="form-luxury-title">Envoyer un Message</h3>
            
            <form onSubmit={handleSubmit} className="luxury-form">
              <div className="form-row">
                <div className="form-group">
                  <label>Nom</label>
                  <input type="text" name="name" placeholder="Votre nom" value={formData.name} onChange={handleChange} required />
                </div>
                <div className="form-group">
                  <label>Email</label>
                  <input type="email" name="email" placeholder="votre.email@exemple.com" value={formData.email} onChange={handleChange} required />
                </div>
              </div>

              <div className="form-group">
                <label>Sujet</label>
                <input type="text" name="subject" placeholder="Sujet de votre message" value={formData.subject} onChange={handleChange} required />
              </div>

              <div className="form-group">
                <label>Message</label>
                <textarea name="message" placeholder="Parlez-moi de votre projet..." value={formData.message} onChange={handleChange} required rows="4"></textarea>
              </div>

              {/* BOUTON DYNAMIQUE */}
              <button 
                type="submit" 
                className="luxury-submit-btn"
                disabled={status === 'sending'}
                style={{ 
                  background: status === 'success' ? '#2ecc71' : '',
                  color: status === 'success' ? '#fff' : '#000'
                }}
              >
                {status === 'sending' ? (
                  <span>Envoi en cours...</span>
                ) : status === 'success' ? (
                  <>
                    <span>Message Envoyé !</span>
                    <CheckCircle size={18} />
                  </>
                ) : status === 'error' ? (
                  <span>Erreur. Réessayez.</span>
                ) : (
                  <>
                    <span>Envoyer le message</span>
                    <Send size={18} className="send-icon" />
                  </>
                )}
              </button>
            </form>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Contact;